import JoyLogo from "../../../assests/Images/TemplateElement/JoyBlueLogo.png";
import { DATE } from "../../../shared/constants.js";
import ImageCardTemplate from "./ImageCardTemplate";

function ImageTemplateCyan({ heading, caption, date, media, journalId,pageRefresh,ref,menuShow }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <ImageCardTemplate
        journalId={journalId}
        imgSrc={media}
        text={caption || heading || ""}
        date={date || DATE.JOURNAL_FORMAT}
        borderColor="#005cff"
        backgroundColor="#0ae2cd"
        imageBottomRight={JoyLogo}
        imageBottomRightStyle={{
          width: { xs: 14, sm: 22, md: 22 },
          height: { xs: 14, sm: 22, md: 22 },
        }}
        textColor="#000000"
        pageRefreshCallback={pageRefresh}
        ref={ref}
        menuShow={menuShow}
      />
    </div>
  );
}

export default ImageTemplateCyan;
